import { render } from "./RuiWarning.vue?vue&type=template&id=4b92c45a"
const script = {}
script.render = render

export default script